import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";
import {PropositionBetsWidgetRowProgressBarValue} from "./proposition-bets-widget.row.progress-bar-value";
import {PROPOSITION_BETS} from "../../../proposition-bets-widgets.consts";
import {HorseshoeProgressBar} from "../../../../../core/components/round-progress-bar/horseshoe-progress-bar/horseshoe.progress-bar";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export const PropositionBetsWidgetRowProgressBar = observer(({controller, row}) => {
  const {device, state} = controller;
  const {isScheduled} = state;
  const {isSmallView} = device;
  const {parameterProgress, paramName, isUnderOver} = row;
  const progressBarDuration: Number = PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.duration * (parameterProgress / 100);

  const baseProps = {
    row,
    controller
  }

  const progressBarProps = {
    radius: isSmallView ? PROPOSITION_BETS.PROGRESS_BAR.SIZES.RADIUS.mobile : PROPOSITION_BETS.PROGRESS_BAR.SIZES.RADIUS.desktop,
    progress: parameterProgress,
    strokeWidth: PROPOSITION_BETS.PROGRESS_BAR.SIZES.stroke,
    strokeColor: useThemeColor(COLORS.accentPrimary),
    strokeBGColor: PROPOSITION_BETS.PROGRESS_BAR.strokeColor,
    hasInitialAnimation: true,
    animationDuration: progressBarDuration,
    animationDelay: PROPOSITION_BETS.PROGRESS_BAR.ANIMATION.delay
  }


  return (
    isUnderOver ? <div className={classNames(styles.parameter_container)}>
        {
          !isScheduled ? <HorseshoeProgressBar {...progressBarProps}/> : null
        }
      <PropositionBetsWidgetRowProgressBarValue {...baseProps}/>
      <div className={classNames(styles.parameter_name, {[styles.parameter_name_scheduled]: isScheduled})}>{paramName}</div>
    </div> : null
  )
});
